import { render, staticRenderFns } from "./feedbackpage.vue?vue&type=template&id=4fe04be9&scoped=true"
import script from "./feedbackpage.vue?vue&type=script&lang=js"
export * from "./feedbackpage.vue?vue&type=script&lang=js"
import style0 from "./feedbackpage.vue?vue&type=style&index=0&id=4fe04be9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe04be9",
  null
  
)

export default component.exports